import { Controller } from "@hotwired/stimulus"

// Affiche ou masque le contenu d'un champ mot de passe (accessibilité).
export default class extends Controller {
  static targets = ["input", "button", "showIcon", "hideIcon"]
  static values = {
    showLabel: { type: String, default: "Afficher le mot de passe" },
    hideLabel: { type: String, default: "Masquer le mot de passe" },
    emptyLabel: { type: String, default: "Saisissez un mot de passe pour pouvoir l'afficher" }
  }

  connect() {
    this.syncAvailability()
  }

  // Sur un formulaire de modification, le champ est vide (le mot de passe
  // enregistré est haché, donc impossible à réafficher) : sans ça le bouton
  // semble cassé puisqu'il « révèle » du vide.
  syncAvailability() {
    if (!this.hasButtonTarget) return

    const empty = this.inputTarget.value.length === 0
    this.buttonTarget.disabled = empty
    this.buttonTarget.classList.toggle("opacity-40", empty)
    this.buttonTarget.classList.toggle("cursor-not-allowed", empty)
    this.buttonTarget.setAttribute(
      "aria-label",
      empty ? this.emptyLabelValue : (this.inputTarget.type === "text" ? this.hideLabelValue : this.showLabelValue)
    )
  }

  toggle(event) {
    const button = event.currentTarget
    const revealed = this.inputTarget.type === "text"

    this.inputTarget.type = revealed ? "password" : "text"
    this.showIconTarget.classList.toggle("hidden", !revealed)
    this.hideIconTarget.classList.toggle("hidden", revealed)

    button.setAttribute("aria-pressed", String(!revealed))
    button.setAttribute("aria-label", revealed ? this.showLabelValue : this.hideLabelValue)
  }
}
